import { message } from "antd";
import API_ROUTES from "app/constants/routes/api";
import { getItem } from "app/utils/session";

import { Service } from "app/config/service";
import get from "lodash/get";
import { setNotificationMessage } from "../home/action";
import {
    addingNewCustomerJob,
    addNewCustomerJobError,
    deleteDeviceFromCustomer,
    getAllCustomersError,
    newCustomerJobAdded,
    setAllCustomers,
    setAllDevice,
} from "./action";
import {
    ADD_NEW_CUSTOMER_JOB,
    GET_ALL_CUSTOMERS,
    GET_DEVICE_DATA,
    REMOVE_DEVICE_FROM_CUSTOMER_MIDDLEWARE
} from "./types";


const { createLogic } = require("redux-logic");

const getAllCustomersLogic = createLogic({
    type: GET_ALL_CUSTOMERS,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");

        const payload = { authToken: authToken ? authToken : "", forRoleId: 12 };

        Service({
            method: "post",
            url: API_ROUTES.GET_ALL_USERS(action.payload),
            data: { ...payload },
        })
            .then((res) => {
                const allCustomerData = get(res, "data.data", {});
                dispatch(
                    setAllCustomers({
                        ...allCustomerData,
                        requestedPage: action.payload,
                    })
                );
                done();
            })
            .catch((err) => {
                dispatch(getAllCustomersError(err));
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const getAllDeviceLogic = createLogic({
    type: GET_DEVICE_DATA,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        const payload = { authToken: authToken ? authToken : "", userId: action.dataId };
        Service({
            method: "post",
            url: API_ROUTES.GET_USER_DEVICES(action.payload),
            data: { ...payload },
        })
            .then((res) => {
                const allDeviceData = get(res, "data.data", {});
                dispatch(
                    setAllDevice({
                        ...allDeviceData,
                        requestedPage: action.payload,
                    })
                );
                done();
            })
            .catch((err) => {
                //dispatch(getAllCustomersError(err));
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const removeDeviceFromCustomer = createLogic({
    type: REMOVE_DEVICE_FROM_CUSTOMER_MIDDLEWARE,
    latest: true,
    process({ action }, dispatch, done) {
        const data = action.payload
        const authToken = getItem("token");

        const payload = {
            authToken: authToken ? authToken : "",
            id: data.id,
            type: data.type,
            userId: data.userId,
        };
        Service({
            method: "post",
            url: API_ROUTES.REMOVE_DEVICES_FROM_CUSTOMER_API,
            data: { ...payload },
        }).then((res) => {

            dispatch(deleteDeviceFromCustomer(payload));
            message.success("Device remove successfully!");
            done();
        }).catch((err) => {
            //dispatch(getAllCustomersError(err));
            dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
            done();
        });
    },
});

const addNewCustomerJobLogic = createLogic({
    type: ADD_NEW_CUSTOMER_JOB,
    latest: true,
    process({ action }, dispatch, done) {
        dispatch(addingNewCustomerJob());
        const token = getItem("token");

        Service({
            method: "post",
            url: API_ROUTES.ADD_JOB,
            data: {
                ...action.payload,
                authToken: token,
            },
        })
            .then(() => {
                dispatch(newCustomerJobAdded());
                dispatch(setNotificationMessage({ type: "success", message: "jobCreateSuccessfully" }))
                done();
            })
            .catch((err) => {
                dispatch(addNewCustomerJobError(err));
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});
export default [
    getAllCustomersLogic,
    addNewCustomerJobLogic,
    getAllDeviceLogic,
    removeDeviceFromCustomer,
];
